import React from 'react';
import { connect } from 'react-redux';
import Config from 'Config';
import { toQueryString } from 'helpers/api.js';
import store from 'blueprint/js/store.js';
import LoadingPage from 'components/Pages/LoadingPage/LoadingPage.jsx';
import MaintenancePage from 'components/Pages/MaintenancePage/MaintenancePage.jsx';
import NoProductsPage from 'components/Pages/NoProductsPage/NoProductsPage.jsx';
import ErrorPage from 'components/Pages/ErrorPage/ErrorPage.jsx';
import { fetchAccount } from './actions.js';


export function requireAuth(Component) {
  class AuthenticatedComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        hasError: false,
        error: '',
        errorStack: '',
      };
    }
    componentDidMount() {
      this.checkAuth({ fetching: false });
    }

    componentDidUpdate() {
      const { fetching, fetched, isAuthenticated, maintenance } = this.props;
      if (!fetching && fetched && !isAuthenticated && !maintenance && process.env.NODE_ENV !== 'test') {
        return this.auth0Redirect(`/auth/login?${toQueryString({ redirect_url: window.location.href })}`);
      }
    }

    componentDidCatch(error, { componentStack }) {
      if (error) {
        this.setState({ error: error.toString(), errorStack: componentStack, hasError: true });
      }
    }

    checkAuth({ fetching }) {
      if ((!fetching && !this.props.error)) {
        store.dispatch(fetchAccount('blueprint'));
      }
    }

    auth0Redirect(path) {
      // for external redirects across apps
      const dev = process.env.NODE_ENV && process.env.NODE_ENV === 'development';
      let url = `${Config.svcFeed.root}${path}`;

      if (dev) {
        url = `${Config.svcFeed.root}${path}`;
      }
      window.location = url;
    }

    render() {
      const { isKnotchAdmin, isAuthenticated, fetching, fetched, maintenance, data: { products } } = this.props;
      const { hasError, errorStack, error } = this.state;

      if (maintenance) {
        return <MaintenancePage />;
      }

      if (process.env.NODE_ENV === 'test') {
        return <Component {...this.props} />;
      }

      if (hasError) {
        return <ErrorPage error={error} isKnotchAdmin={isKnotchAdmin} errorStack={errorStack} />;
      }

      if (isAuthenticated) {
        if (products.includes('blueprint')) {
          return <Component {...this.props} />;
        }

        return <NoProductsPage logOutPath={'/blueprint/logout'} />;
      }

      if (!fetching && !fetched) {
        this.checkAuth({ fetching });
        return <LoadingPage />;
      }

      if (fetching) {
        return <LoadingPage />;
      }

      return <LoadingPage />;
    }
  }

  const mapStateToProps = ({ Account }) => Account;

  return {
    test: AuthenticatedComponent,
    connected: connect(mapStateToProps)(AuthenticatedComponent),
  };
}
